import { Button } from "@/components/Button";
import { Select } from "@/components/Select";

const SPEEDS = [1, 2, 4, 8] as const;

export function formatPlaybackTime(seconds: number): string {
  const whole = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(whole / 60);

  return `${minutes}:${(whole % 60).toString().padStart(2, "0")}`;
}

export function ReplayControls({
  position,
  duration,
  playing,
  speed,
  onPlayPause,
  onSeek,
  onSpeedChange,
}: {
  position: number;
  duration: number;
  playing: boolean;
  speed: number;
  onPlayPause: () => void;
  onSeek: (seconds: number) => void;
  onSpeedChange: (speed: number) => void;
}) {
  return (
    <div className="mt-3 flex items-center gap-3">
      <Button onClick={onPlayPause} className="w-20">
        {playing ? "Pause" : "Play"}
      </Button>

      <span className="w-12 text-right font-mono text-xs text-foreground/70">
        {formatPlaybackTime(position)}
      </span>

      <input
        type="range"
        min={0}
        max={duration || 0}
        step={0.1}
        value={Math.min(position, duration || 0)}
        onChange={(event) => onSeek(Number(event.target.value))}
        className="accent-accent min-w-0 flex-1"
        aria-label="Seek"
      />

      <span className="w-12 font-mono text-xs text-foreground/70">
        {formatPlaybackTime(duration)}
      </span>

      <Select
        value={speed}
        onChange={(event) => onSpeedChange(Number(event.target.value))}
        aria-label="Playback speed"
        className="w-20"
      >
        {SPEEDS.map((option) => (
          <option key={option} value={option}>
            {option}x
          </option>
        ))}
      </Select>
    </div>
  );
}
